import React from 'react';
import { Fade } from 'react-reveal';
import CertificateCard from './certificateCard/CertificateCard';
import './Certifications.css';

const Certifications = () => {
  return (
    <div className='main' id='certs'>
      <div className='certs-header-div'>
        <Fade bottom duration={2000} distance='20px'>
          <h1 className='certs-header'>Certifications</h1>
        </Fade>
      </div>
      <div className='certs-body-div'>
        <CertificateCard />
      </div>
    </div>
  );
};

export default Certifications;
